import { IconAlertWhite } from "../../../../../common/icons/IconAlertWhite/IconAlertWhite";
import { IconGift } from "../../../../../common/icons/IconGift/IconGift";
import "./LegendIcon.scss";

export const SopLegendIcon = ({ type, fullWidth = false }: { type: "promo" | "expiry"; fullWidth?: boolean }) => {
  const bgColor = type === "promo" ? "green" : "orange";

  const classes = [`SopLegendIcon--${bgColor}`];
  if (fullWidth) {
    classes.push("SopLegendIcon--full");
  }
  return (
    <div className={`SopLegendIcon ${classes.join(" ")}`}>{type === "promo" ? <IconGift /> : <IconAlertWhite />}</div>
  );
};
